import { useMutation } from "@tanstack/react-query";
import { Button, Dropdown, Modal } from "@weirgroup/weir-dls";
import { useContext, useEffect, useMemo, useState } from "react";
import timezones from "timezones-list";
import { useTranslation } from "react-i18next";

import { AppConfigContext } from "../../contexts/app-config.context";
import { BasicModalType } from "../../types/basic-modal.type";
import { UserSettingType } from "../../types/user.type";
import userSettingsApi from "../../api/settings.api";

import "./styles.scss"
import { useDarkMode } from "../../hooks/use-darkmode";
import { useAnalyticsEvent } from "../../hooks/useAnalyticsEvent";

export default function TimezoneModal(props: Readonly<BasicModalType>) {
  const logAnalyticsEvent = useAnalyticsEvent();
  const { t } = useTranslation();
  const appConfigStore = useContext(AppConfigContext);
  const timezoneList = useMemo(() => {
    return timezones.map((tz) => ({ name: tz.name, value: tz.tzCode }));
  }, []);
  const { mutateAsync, isPending: isLoading } = useMutation({ mutationFn: userSettingsApi.updateUserSettings });
  const [timezone, setTimezone] = useState(appConfigStore.timezone);
  const { open, toggleDialog } = props;
  const {darkMode} = useDarkMode()
  useEffect(() => {
    setTimezone(appConfigStore.timezone);
  }, [appConfigStore.timezone])

  const updateStore = async () => {
    appConfigStore.setTimezone(timezone);
    const userSettings: UserSettingType = {
      language: appConfigStore.language,
      timezone,
      units: appConfigStore.units,
      asset_email_notification: appConfigStore.assetEmailNotification,
      geofence_email_notification: appConfigStore.geofenceEmailNotification,
      inapp_notification: appConfigStore.inAppNotification
    }
    await mutateAsync(userSettings);
    toggleDialog?.();
    logAnalyticsEvent('user_updated_timezone', { description: 'User updated their timezone setting' });
  };

  return (
    <Modal
      darkMode={darkMode}
      showModal={open}
      onClose={toggleDialog}
      size="small"
      dismissable
    >
      <div className="time-zone-container">
        <Dropdown
          darkMode={darkMode}
          label={t("selectTimezone")}
          canvasDeviceSize="phone"
          selectData={timezoneList}
          value={timezone}
          setValue={setTimezone}
          optionsOverlay={false}
        />
        <div className="set-btn">
          <Button
            darkMode={darkMode}
            label={t("set")}
            onClick={updateStore}
            isLoading={isLoading}
            disabled={isLoading}
          />
        </div>
      </div>
    </Modal>
  );
}
